import useApi from '@booking/composables/useApi'
import { parseBookingOrderId } from '@booking/utils/bookingOrderId'

export default defineNuxtRouteMiddleware(async to => {
  if (!to.path.startsWith('/orders/')) {
    return
  }

  const id = parseBookingOrderId(String(to.params.id))
  if (typeof id !== 'number') {
    return
  }

  const { uuid } = await useApi().orders.get(id)
  if (!uuid || typeof parseBookingOrderId(uuid) !== 'string') {
    throw createError({ statusCode: 404 })
  }

  return navigateTo(
    {
      path: to.path.replace(/^\/orders\/[^/]+/, `/orders/${uuid}`),
      query: to.query,
      hash: to.hash,
    },
    { redirectCode: 302, replace: true },
  )
})
